import config from '../config';
import { isMakeOrgMember } from './is-make-org-member';

// AI Chats / AI Feedback insights are limited to MAKE org members
// and to the explicitly allowed staff accounts of other organizations.
export const canAccessAiInsights = (email?: string | null): boolean =>
    isMakeOrgMember(email) ||
    (!!email && config.aiInsightsAllowedEmails.includes(email.toLowerCase()));
